import { render, staticRenderFns } from "./rPage.vue?vue&type=template&id=219ac2b1&scoped=true"
import script from "./rPage.vue?vue&type=script&lang=js"
export * from "./rPage.vue?vue&type=script&lang=js"
import style0 from "./rPage.vue?vue&type=style&index=0&id=219ac2b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ac2b1",
  null
  
)

export default component.exports